import { t } from "i18next";

const tAsString = (key: string) => t(key) ?? "?";

export default tAsString;
